import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=684e3dac"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports